export const GET_APPLICANT_REPORTS_REQUEST = "GET_APPLICANT_REPORTS_REQUEST";
export const UPLOAD_APPLICANT_REPORTS_REQUEST =
  "UPLOAD_APPLICANT_REPORTS_REQUEST";
export const DELETE_APPLICANT_REPORTS_REQUEST =
  "DELETE_APPLICANT_REPORTS_REQUEST";
export const DELETE_APPLICANT_REPORTS_RESPONSE =
  "DELETE_APPLICANT_REPORTS_RESPONSE";
export const UPLOAD_APPLICANT_REPORTS_RESPONSE =
  "UPLOAD_APPLICANT_REPORTS_RESPONSE";
export const GET_APPLICANT_REPORTS_RESPONSE = "GET_APPLICANT_REPORTS_RESPONSE";
export const GET_APPLICANT_DOWNLOAD_REPORTS_RESPONSE =
  "GET_APPLICANT_DOWNLOAD_REPORTS_RESPONSE";

export const EXPORT_APPLICANT_REPORT_SHEET_REQUEST =
  "EXPORT_APPLICANT_REPORT_SHEET_REQUEST";
export const EXPORT_APPLICANT_REPORT_SHEET_REQUEST_ALL =
  "EXPORT_APPLICANT_REPORT_SHEET_REQUEST_ALL";
